import { VenueCancelInviteInput } from '../../graphql/API';
import { executeGql } from '../../utils/gql-utils';

const venueCancelInviteMutation = /* GraphQL */ `
  mutation venueCancelInvite($input: VenueCancelInviteInput!) {
    venueCancelInvite(input: $input)
  }
`;

export const venueCancelInviteApi = async (input: VenueCancelInviteInput): Promise<void> => {
  await executeGql<void>(venueCancelInviteMutation, { input });
};
